export default "https://legacy.eskolare-development.com/images/collections.png";